import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';
import markdownit from 'markdown-it';
import 'github-markdown-css/github-markdown.css';
import axios from 'axios';
import { BContainer,BButton,BRow,BCol } from "bootstrap-vue-next";

export default {
  name: 'Home',
  components: {
    Loading,BContainer,BButton,BRow,BCol
  },

  // 共通関数
  //mixins: [netutils],

  // ローカルデータ変数
  data() {
    return {
      // メッセージ
      message: {
        is_alert: false,
        variant: "",
        message: "",
      },
      // ローディング
      loader: {
        is_loading: false,
        is_full_page: true,
      },
      // バインドデータ
      bind_data: {
        markdownit: null, //マークダウンオブジェクト
        markdowntext: "", //HTML化したテキスト
      },
      // ローカルデータ
      local_data: {
      },
      // 状態データ
      state_data: {
      }
    }
  },

  // 既定計算
  computed: {
  },

  // インスタンス初期化後
  created: function(){
    this.bind_data.markdownit = new markdownit();
  },
  // インスタンス破棄後
  destroyed: function() {
  },
  // インスタンスマウント後
  mounted: async function(){
    
    // ローディング開始
    this.loader.is_loading = true;

    let href = window.location.href;
    console.log("Home:href="+href);

    this.local_data.markdowntext = await axios.get("/qa.md");
    console.log(this.local_data.markdowntext.data);
    //this.bind_data.markdowntext = this.bconvert(this.bind_data.markdownit.render(this.local_data.markdowntext));
    this.bind_data.markdowntext = this.bind_data.markdownit.render(this.local_data.markdowntext.data);
    console.log(this.bind_data.markdowntext);

    // ローディング終了
    this.loader.is_loading = false;
  },

  // ローカル関数
  methods: {
    home(){
      // 画面遷移
      this.$router.push({ path:'/Home' });
    },
    qa(){
      // 画面遷移
      this.$router.push({ path:'/QA' });
    },
    privacy_policy(){
      // 画面遷移
      this.$router.push({ path:'/PrivacyPolicy' });
    },
    terms_of_service(){
      // 画面遷移
      this.$router.push({ path:'/TermsOfService' });
    },
  }
}
